import { useEffect } from "react";
import ReactGA from "react-ga4";

export function usePageView() {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);
}

export function useSearchTracking(searchTerm: string) {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchTerm) {
        ReactGA.event({
          category: "Search",
          action: "Search VCs",
          label: searchTerm,
        });
      }
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);
}
